module.exports = __webpack_public_path__ + "TextaNarrow-Bold-webfont.9807a6626a1aab4739f2.woff";


//////////////////
// WEBPACK FOOTER
// /Users/ugyen/Documents/Bhutan-office/my_bhutan/mybhutan-travel/src-admin/assets/fonts/TextaNarrow-Bold-webfont.woff
// module id = ../../../../../src-admin/assets/fonts/TextaNarrow-Bold-webfont.woff
// module chunks = styles